import { render } from "./DisplayType.vue?vue&type=template&id=46af04a6&scoped=true&ts=true"
import script from "./DisplayType.ts?vue&type=script&lang=ts"
export * from "./DisplayType.ts?vue&type=script&lang=ts"

import "./DisplayType.scss?vue&type=style&index=0&id=46af04a6&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46af04a6"]])

export default __exports__